export interface IDecodedDrillDownFilterSelectionId {
  facetKey: string
  optionId: string
}

export const encodeDrillDownFilterSelectionId = (
  facetKey: string,
  optionId: string,
): string => JSON.stringify([facetKey, optionId])

export const decodeDrillDownFilterSelectionId = (
  id: string,
): IDecodedDrillDownFilterSelectionId | null => {
  try {
    const parsed = JSON.parse(id)
    if (
      Array.isArray(parsed) &&
      parsed.length === 2 &&
      typeof parsed[0] === 'string' &&
      typeof parsed[1] === 'string'
    ) {
      return {
        facetKey: parsed[0],
        optionId: parsed[1],
      }
    }
  } catch {
    return null
  }

  return null
}
